const Logo = () => (
	<img src="images/logo-al.png" alt="ALLCOM TRADE" />
);

export default Logo;
